export function contact_mitsumori_trump() {

    const handleRadio = () => {
        const radio = $('input[name="paper"]');
        const select = $('select[name="paper01"]');
        select.attr('disabled', 'disabled');
        radio.on('change', function (e) {
            const parent = $(this).parents('.group02-item');
            const target = parent.find('select[name="paper01"]');
            select.attr('disabled', 'disabled')
            target.attr('disabled', false)
        });
    };
    handleRadio();

}